import { Button } from 'antd';
import { DateTime } from 'luxon';
import React from 'react';
import { useDispatch } from 'react-redux';

import { FORMAT_DATE } from '../const';
import { ComponentsDispatch } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';

const ButtonToday = () => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const onCLickToday = () => {
        console.log('click Today Button');
        dispatch(
            setterCalendar({
                currentDate: DateTime.now().toFormat(FORMAT_DATE),
            }),
        );
    };

    return (
        <Button type={'default'} onClick={onCLickToday}>
            Today
        </Button>
    );
};

export default ButtonToday;
